(() => {
  const HUB_SELECTOR = "[data-epeios-recipe-hub]";

  const normaliseFilterToken = (value) => String(value || "").trim().toLocaleLowerCase("ja-JP");

  const foldHiraganaToKatakana = (value) => Array.from(value)
    .map((character) => {
      const codePoint = character.codePointAt(0);

      if (codePoint >= 0x3041 && codePoint <= 0x3096) {
        return String.fromCodePoint(codePoint + 0x60);
      }

      return character;
    })
    .join("");

  // Keep the published ingredient text as the source of truth. This only folds
  // equivalent Japanese input forms; it does not infer synonyms or substitutes.
  const normaliseSearchText = (value) => {
    const input = String(value || "");
    const nfkc = typeof input.normalize === "function" ? input.normalize("NFKC") : input;

    return foldHiraganaToKatakana(nfkc)
      .toLocaleLowerCase("ja-JP")
      .replace(/[ \t\r\n\u3000]/g, "")
      .replace(/[()［］【】「」『』、，,．。・:：;；]/g, "");
  };

  const initialiseHub = (hub) => {
    if (hub.dataset.recipeHubReady === "true") return;

    const cards = Array.from(hub.querySelectorAll("[data-recipe-card]"));
    const deviceButtons = Array.from(hub.querySelectorAll("[data-recipe-device]"));
    const searchInput = hub.querySelector("[data-recipe-search]");
    const heroSearchInput = hub.querySelector("[data-recipe-hero-search]");
    const heroSearchForm = hub.querySelector("[data-recipe-hero-form]");
    const categorySelect = hub.querySelector("[data-recipe-category]");
    const filterForm = hub.querySelector("[data-recipe-filter-form]");
    const recipeIndex = hub.querySelector("#recipe-index");
    const visibleCount = hub.querySelector("[data-recipe-visible-count]");
    const emptyState = hub.querySelector("[data-recipe-empty]");
    let selectedDevice = "";

    const updateCards = () => {
      const searchTerm = normaliseSearchText(searchInput?.value);
      const selectedCategory = normaliseFilterToken(categorySelect?.value);
      let matches = 0;

      cards.forEach((card) => {
        const tags = normaliseFilterToken(card.dataset.recipeTags)
          .split("|")
          .filter(Boolean);
        const searchable = normaliseSearchText(card.dataset.recipeSearch);
        const matchesDevice = !selectedDevice || tags.includes(normaliseFilterToken(selectedDevice));
        const matchesCategory = !selectedCategory || tags.includes(selectedCategory);
        const matchesSearch = !searchTerm || searchable.includes(searchTerm);
        const isVisible = matchesDevice && matchesCategory && matchesSearch;

        card.hidden = !isVisible;
        if (isVisible) matches += 1;
      });

      if (visibleCount) visibleCount.textContent = String(matches);
      if (emptyState) emptyState.hidden = matches !== 0;
    };

    deviceButtons.forEach((button) => {
      button.addEventListener("click", () => {
        selectedDevice = button.dataset.recipeDevice || "";
        deviceButtons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle("is-active", isActive);
          item.setAttribute("aria-pressed", String(isActive));
        });
        updateCards();
        recipeIndex?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    searchInput?.addEventListener("input", () => {
      if (heroSearchInput) heroSearchInput.value = searchInput.value;
      updateCards();
    });
    heroSearchInput?.addEventListener("input", () => {
      if (searchInput) searchInput.value = heroSearchInput.value;
      updateCards();
    });
    categorySelect?.addEventListener("change", updateCards);
    filterForm?.addEventListener("submit", (event) => event.preventDefault());
    heroSearchForm?.addEventListener("submit", (event) => {
      event.preventDefault();
      if (searchInput && heroSearchInput) searchInput.value = heroSearchInput.value;
      updateCards();
      recipeIndex?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    filterForm?.addEventListener("reset", () => {
      selectedDevice = "";
      deviceButtons.forEach((button, index) => {
        const isActive = index === 0;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", String(isActive));
      });
      window.requestAnimationFrame(() => {
        if (heroSearchInput && searchInput) heroSearchInput.value = searchInput.value;
        updateCards();
      });
    });

    hub.dataset.recipeHubReady = "true";
    updateCards();
  };

  const initialise = () => document.querySelectorAll(HUB_SELECTOR).forEach(initialiseHub);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise, { once: true });
  } else {
    initialise();
  }
})();
